import { componentsDeMessages, componentsEnMessages } from "@scayla/components";
import { createScaylaI18n } from "@scayla/core";

import frontendDeMessages from "./locales/de.json";
import frontendEnMessages from "./locales/en.json";

function deepMerge(base: Record<string, unknown>, override: Record<string, unknown>): Record<string, unknown> {
  const result = { ...base };
  for (const key of Object.keys(override)) {
    const baseVal = result[key];
    const overrideVal = override[key];
    if (
      baseVal &&
      overrideVal &&
      typeof baseVal === "object" &&
      typeof overrideVal === "object" &&
      !Array.isArray(baseVal)
    ) {
      result[key] = deepMerge(baseVal as Record<string, unknown>, overrideVal as Record<string, unknown>);
    } else {
      result[key] = overrideVal;
    }
  }
  return result;
}

export const i18n = createScaylaI18n({
  de: deepMerge(componentsDeMessages as Record<string, unknown>, frontendDeMessages as Record<string, unknown>),
  en: deepMerge(componentsEnMessages as Record<string, unknown>, frontendEnMessages as Record<string, unknown>),
});

export const $t = (key: string, params?: Record<string, unknown> | number): string =>
  typeof params === "number" ? i18n.global.t(key, params) : i18n.global.t(key, params ?? {});

export const getAvailableLanguages = () => [
  { id: "de", label: $t("common.label.languages.de") },
  { id: "en", label: $t("common.label.languages.en") },
];
